import AssetsManager from './assets-manager';

const getLoaderObject = () => ({
    progress: 0,
    loaded: false,
    items: [],
    contexts: [],
});

const AssetsMixin = (manifest = 'core') => ({
    props: {
        loaded: false,
    },

    async onBeforeSetup() {
        if (this.addDynamicAssets) this.addDynamicAssets({ props: this.props, options: this.options });

        if (!this.assets) return;

        this.assetsManifest = manifest;

        // Add manifest to assets manager
        if (!AssetsManager.manifests[manifest]) {
            AssetsManager.manifests = Object.assign({}, AssetsManager.manifests, { [manifest]: getLoaderObject() });
        }

        // Reset preloader
        AssetsManager.manifests[manifest].progress = 0;
        AssetsManager.manifests[manifest].loaded = false;

        // Add context reference of each manifest
        AssetsManager.manifests[manifest].contexts.push(this);

        // Parse assets (e.g. check uppercase pathnames)
        this.assets = this.parseAssets();

        // Add assets to items array
        AssetsManager.manifests[manifest].items.push(...this.assets);
    },

    parseAssets() {
        return Object.entries(this.assets).map(([key, url]) => {
            // check if assets are lowercase, otherwise warn the user and lowercase it
            const lowercased = url.toLowerCase();
            if (url !== lowercased) {
                console.warn('[AssetsMixin] Asset urls should be lowercase!', url);
                url = lowercased;
            }

            return { key, url, contextIndex: AssetsManager.manifests[manifest].contexts.length - 1 };
        });
    },

    async preload() {
        await AssetsManager.preloadManifest(this.assetsManifest, (progress) => {
            if (this.onAssetsPreloaderProgress) {
                this.onAssetsPreloaderProgress(progress);
            }
        });
    },

    onAssetsPreloaderProgress() {},
    onAssetsPreloaderComplete() {
        this.props.loaded = true;
    },
});

export default AssetsMixin;
